// Locations
export const RequestedLocationCountDefault = 8;
export const MinLocationCount = 1;
export const MaxLocationCount = 10;

// Adventures
export const RequestedAdventuresCountDefault = 2;
export const MinAdventureCount = 1;
export const MaxAdventureCount = 4;

// Collab Summary
export const DaysCreatorsHaveToApply = 7;
export const DaysToChooseCreator = 10;

// Choose creator date constants
export const ChooseCreatorRecommendedDaysLimit = 8;
export const ChooseCreatorDaysLimitWithoutWarning = 14;
